<div class="row" [ngStyle]="margin() ? { 'margin-top': margin(), 'margin-bottom': margin() } : null">
    <ng-content></ng-content>
</div>
